import axios from "axios";
var URL = "/groups";

var getActions = function getActions(groupId) {
  return axios.get("/groups/" + groupId + "/actions?include=user,meeting,agendaItem");
};

var getCompetedActions = function getCompetedActions(groupId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return axios.get("/groups/" + groupId + "/actions-completed?include=user,meeting,agendaItem&page=" + page);
};

var getMyActions = function getMyActions() {
  return axios.get("/my-actions?include=meeting.group.organization,agendaItem");
};

var getMyCompletedActions = function getMyCompletedActions() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return axios.get("/my-completed-actions?include=meeting.group.organization,agendaItem&page=" + page);
};

var getMeetingActions = function getMeetingActions(groupId, meetingId) {
  return axios.get("/groups/" + groupId + "/meetings/" + meetingId + "/actions?include=user,meeting,agendaItem");
};

var storeAction = function storeAction(groupId, request) {
  return axios.post("/groups/" + groupId + "/actions", request);
};

var updateAction = function updateAction(groupId, actionId, request) {
  return axios.put("/groups/" + groupId + "/actions/" + actionId, request);
};

var updateMyAction = function updateMyAction(actionId, request) {
  return axios.put("/my-actions/" + actionId, request);
};

var destroyAction = function destroyAction(groupId, actionId) {
  return axios.delete("/groups/" + groupId + "/actions/" + actionId);
};

export { getActions, getCompetedActions, getMyActions, getMyCompletedActions, getMeetingActions, storeAction, updateAction, updateMyAction, destroyAction };